import React from "react";
import "./pickup_logistics.css";

export default function PickupLogisticsDetails({ onQuote }) {
  const rows = [
    { fund: "100,000", type2p: "9,000", type3p: "7,900" },
    { fund: "150,000", type2p: "10,400", type3p: "8,800" },
    { fund: "200,000", type2p: "11,900", type3p: "9,200" },
    { fund: "250,000", type2p: "12,500", type3p: "10,000" },
    { fund: "300,000", type2p: "13,100", type3p: "10,600" },
    { fund: "350,000", type2p: "13,800", type3p: "11,300" },
    { fund: "400,000", type2p: "14,400", type3p: "11,900" },
    { fund: "450,000", type2p: "15,100", type3p: "12,600" },
    { fund: "500,000", type2p: "15,700", type3p: "13,200" },
  ];

  return (
    <div className="pkg-detail pickup-logistics">
      <h2>รหัส 320 — Logistics 2+ / 3+</h2>
      <p>รถบรรทุก ≤4 ตัน (ขนส่งเชิงพาณิชย์, คอก/ตู้บรรทุกสินค้า)</p>

      <table className="pkg-table">
        <thead>
          <tr>
            <th>ทุนประกันภัย</th>
            <th>2+ เบี้ยรวม (บาท)</th>
            <th>3+ เบี้ยรวม (บาท)</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.fund}>
              <td>{r.fund}</td>
              <td>{r.type2p}</td>
              <td>{r.type3p}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pkg-foot">
        <p>เริ่มใช้ 16 ก.ค. 2567 – สิ้นสุด 31 ธ.ค. 2567</p>
        <p>* รวมส่วนลด CCTV และ App แจ้งเหตุแล้ว</p>
        <button className="pkg-quote-btn" onClick={onQuote}>
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
